import { applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import reducer from './reducers';
import { configureStore } from '@reduxjs/toolkit';

const enhancer = compose(applyMiddleware(logger, thunk));

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth', 'common']
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    // Workaround for now as it won't break anything, but we should
    // really look at replacing the model classes with pure javascript objects
    serializableCheck: false
  }),
  enhancers: (defaultEnhancers) => [enhancer, ...defaultEnhancers]
})

export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store);
